/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Publicsessions1Inputs */

const zh_learn_publicsessions1 = /** @type {(inputs: Learn_Publicsessions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公开资源`)
};

const en_learn_publicsessions1 = /** @type {(inputs: Learn_Publicsessions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public Resources`)
};

const es_learn_publicsessions1 = /** @type {(inputs: Learn_Publicsessions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recursos públicos`)
};

/**
* | output |
* | --- |
* | "Public Resources" |
*
* @param {Learn_Publicsessions1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_publicsessions1 = /** @type {((inputs?: Learn_Publicsessions1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Publicsessions1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_publicsessions1(inputs)
	if (locale === "en") return en_learn_publicsessions1(inputs)
	return es_learn_publicsessions1(inputs)
});
export { learn_publicsessions1 as "learn_publicSessions" }